import React from 'react';
import SharedTemplates from '../../../components/templates/SharedTemplates';

const Templates = () => {
  return <SharedTemplates isAdmin={true} />;
};

export default Templates;
